module.exports = __webpack_public_path__ + "img/agricultura-selecionado.7f0e005c.svg";